import getQueryParams from '@/utils/getQueryParams';
import store from '@/store/BookingStore';
import { UserInfo } from '../../../../../requests-module/src';

function decodeBase64Utf8(base64String) {
    // Decode the Base64 string to a binary string
    const binaryString = atob(base64String);

    // Convert the binary string to a UTF-8 string
    const utf8String = decodeURIComponent(escape(binaryString));

    return utf8String;
}

export function hanldeSecureless(): boolean {
    try {
        const queryParams = getQueryParams()
        if (!queryParams.info) return false;

        if (queryParams.info) {
            const decodedinfo = decodeBase64Utf8(queryParams.info) // todo
            const [email, first_name, last_name] = decodedinfo.split('|')
            const cleanEmail = email.split('=')[1]
            const cleanFirstName = first_name.split('=')[1]
            const cleanLastName = last_name.split('=')[1]
            const userInfo: Partial<UserInfo> = {
                email: cleanEmail,
                first_name: cleanFirstName,
                last_name: cleanLastName,
                gender: '',
                postal_code: "",
                city: "",
                phone_number: "",
                phone_code: "",
                country: "",
                address: "",
                site_locale: "",
                iresa_id: "",
            }
            store.commit('setLoggedUser', userInfo)
            return true
        }

        return false

    } catch (error) {
        return false
    }
}